// extracted by mini-css-extract-plugin
module.exports = {"truncate":"a1LUFxQ","linkContainer":"funT1RN"};